import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { setupAxiosInterceptors } from './components/utils/setupAxiosInterceptors.js';
import { msalConfig } from '../src/components/utils/msalConfig.js';
import { msalConfigB2C } from '../src/components/utils/msalConfigB2C.js';
import { msalInstanceAzureAD, msalInstanceAzureADB2C } from "./components/utils/msalInstances.js";
import { MsalInstancesProvider } from "./components/utils/MsalInstancesContext.js";
import "./globalStyles/styles.css";
setupAxiosInterceptors();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalInstancesProvider
      azureADInstance={msalInstanceAzureAD}
      b2cInstance={msalInstanceAzureADB2C}
    >
      <App />
    </MsalInstancesProvider>
  </React.StrictMode>
);
reportWebVitals();


